import React, { FC } from 'react';
import { Menu as AntdMenu } from 'antd';
import { MenuItemProps } from 'antd/es/menu/MenuItem';
import styled from 'styled-components';

const MenuItem: FC<MenuItemProps> = (props) => {
  const { children } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledAntdItem {...props} rootPrefixCls="ant-menu">
      {children}
    </StyledAntdItem>
  );
};

const StyledAntdItem = styled(AntdMenu.Item)`
  &.ant-menu-item {
    display: flex;
    @media screen and (min-width: ${(props) => props.theme.breakpoints.large}) {
      min-width: 110px;
      justify-content: center;
    }
  }
  align-items: center;
  padding: 0 ${(props) => props.theme.paddings.huge};
  color: ${(props) => props.theme.color.titleColor};

  @media screen and (max-width: ${(props) => props.theme.breakpoints.large}) {
    margin: 0 ${(props) => props.theme.margins.medium};
  }

  &:hover {
    a {
      color: ${(props) => props.theme.color.titleColor} !important; // rewriting styles from .less
    }
  }

  &.ant-menu-item-selected {
    svg {
      fill: ${(props) => props.theme.color.titleColor};
    }
    span {
      color: ${(props) => props.theme.color.titleColor};
    }

    @media screen and (min-width: ${(props) => props.theme.breakpoints.large}) {
      border-bottom: 2px solid ${(props) => props.theme.color.titleColor} !important; // rewriting styles from .less
      color: ${(props) => props.theme.color.titleColor} !important; // rewriting styles from .less
    }
  }

  &.ant-menu-item-active {
    @media screen and (min-width: ${(props) => props.theme.breakpoints.large}) {
      border-bottom: 2px solid ${(props) => props.theme.color.titleColor} !important; // rewriting styles from .less
      color: ${(props) => props.theme.color.titleColor} !important; // rewriting styles from .less
    }
  }
`;

export default MenuItem;
